<iframe #iframe [style.width]="width"></iframe>